module.exports = {"650521100":"巴里坤镇","650521101":"博尔羌吉镇","650521102":"大河镇","650521103":"奎苏镇","650521104":"三塘湖镇","650521200":"萨尔乔克乡","650521201":"海子沿乡","650521202":"下涝坝乡","650521205":"石人子乡","650521206":"花园乡","650521208":"大红柳峡乡","650521209":"八墙子乡","650521400":"良种繁育场","650521401":"黄土场开发区","650521402":"巴里坤县山南开发区","650521500":"兵团红山农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650521.json
// module id = 3207
// module chunks = 0